<template>
  <v-menu v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px">
    <template #activator="{ on, attrs }">
      <v-text-field v-model="displayValue"
                    :label="label"
                    :prepend-icon="icon"
                    :clearable="clearable"
                    :readonly="readonly"
                    :disabled="disabled"
                    :error-messages="errorMessages"
                    :hide-details="hideDetails"
                    :dense="dense"
                    :outlined="outlined"
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="handleClear">
        <template #append>
          <v-icon>mdi-calendar</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker :value="pickerValue"
                   type="month"
                   :locale="locale"
                   :min="min"
                   :max="max"
                   :allowed-dates="allowedDates"
                   scrollable
                   @input="handleChange">
      <v-spacer></v-spacer>
      <v-btn text
             color="primary"
             @click="menu = false">
        Fechar
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'MonthYearPicker',
  props: {
    value: {
      type: [String, Object],
      default: null
    },
    label: {
      type: String,
      default: 'Mês/Ano'
    },
    icon: {
      type: String,
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    hideDetails: {
      type: [Boolean, String],
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: 'pt-BR'
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    allowedDates: {
      type: Function,
      default: null
    },
  },
  data() {
    return {
      menu: false,
      internalValue: this.value
    }
  },
  computed: {
    displayValue() {
      if (!this.internalValue) return null
      
      let yearStr, monthStr
      
      // Handle both object and string formats
      if (typeof this.internalValue === 'object' && this.internalValue && this.internalValue.formatted) {
        [yearStr, monthStr] = this.internalValue.formatted.split('-')
      } else if (typeof this.internalValue === 'string') {
        [yearStr, monthStr] = this.internalValue.split('-')
      } else {
        return null
      }
      
      const monthNames = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]
      
      const monthIndex = parseInt(monthStr) - 1
      return `${monthNames[monthIndex]}/${yearStr}`
    },
    pickerValue() {
      // Return string format for v-date-picker
      if (!this.internalValue) return null
      
      if (typeof this.internalValue === 'object' && this.internalValue.formatted) {
        return this.internalValue.formatted
      } else if (typeof this.internalValue === 'string') {
        return this.internalValue
      }
      return null
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal
    }
  },
  methods: {
    handleChange(value) {
      this.internalValue = value
      
      // Always return object with year and month for consistency
      if (value) {
        const [year, month] = value.split('-')
        this.$emit('input', {
          year: parseInt(year),
          month: parseInt(month),
          formatted: value
        })
      } else {
        this.$emit('input', null)
      }
      
      this.menu = false
    },
    handleClear() {
      this.internalValue = null
      this.$emit('input', null)
    }
  }
}
</script>